module.exports = __webpack_public_path__ + "static/img/car5.a8acaed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/car5.png
// module id = szXf
// module chunks = 1